import React from "react";
import { Link } from "react-router-dom";
import { Loading } from "components/common";
import classnames from "classnames";
import "../styles/marketing-dashboard.css";

const MarketingButtons = ({
  prevButton,
  prevLink,
  nextButton,
  nextLink,
  required,
  submit,
  loading,
  discardChanges,
  spaceBetween
}) => {
  return (
    <>
      {loading && <Loading />}
      <div
        className={classnames(
          "flex my-5 py-2 rounded-lg animate__animated animate__fadeIn ease-in-out",
          { "justify-evenly mx-auto px-3": !spaceBetween },
          { "justify-between": spaceBetween }
        )}
      >
        {discardChanges ? (
          <button
            type="button"
            className="btn text-sm bg-red-500 mr-2 border-none"
            onClick={() => discardChanges()}
          >
            {prevButton}
          </button>
        ) : (
          <Link to={prevLink}>
            <button
              type="button"
              className="btn text-sm bg-red-500 mr-2 border-none"
            >
              {prevButton}
            </button>
          </Link>
        )}
        {submit ? (
          <button
            type="button"
            className="btn text-sm bg-green-500 ml-2 border-none"
            disabled={required}
            onClick={submit}
          >
            {nextButton}
          </button>
        ) : (
          <Link to={nextLink}>
            <button
              type="button"
              className="btn text-sm bg-green-500 ml-2 border-none"
              disabled={required}
            >
              {nextButton}
            </button>
          </Link>
        )}
      </div>
    </>
  );
};

export default MarketingButtons;
